import { Component, OnInit } from "@angular/core";
import { environment } from "../../../../../environments/environment";
import { ApiService } from "../../../../servicios/api.service";

@Component({
    selector: 'app-noticias-portada',
    templateUrl: 'noticias-portada.component.html',
    styleUrls: ['noticias-portada.component.scss']
})
export class NoticiasPortadaComponent implements OnInit {
    public noticias = [];
    public urlNoticiasImg = environment.imgNoticias;

    constructor(private _api: ApiService) {

    }


    ngOnInit() {
        this._api.get('noticias-portada').subscribe((res: any) => {
            this.noticias = this._api.reader.read(res, []);
            setTimeout(() => {
                this.sliderNoticiasPortada();
            }, 150);
        })
    }

    private sliderNoticiasPortada() {
        var nPortadaSlide: any = $('.nPortada_slider');
        nPortadaSlide.owlCarousel({
            loop: this.noticias.length > 3 ? true : false,
            margin: 0,
            autoplay: this.noticias.length > 3 ? true : false,
            dots: false,
            items: 3
        });
    }
}